/** @module csi/heading/StringType */
define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/locale",
	"csi/store/Classes",
	"csi/widget/InlineSelect",
	"csi/xml",
	"./String"
], function(declare,csiHeading,locale,Classes,InlineSelect,xml,StringRen) {

	return declare(StringRen, {
		// limit query operations to EQ/NE so the client can send full class names to the server to filter by (substrings won't work)
		queryOps: csiHeading.QUERY_OPS[xml.ATTR_ENUM],

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: display localized name for stored type
			return locale.type(value) || "";
		},

		toHtmlQueryFilter: function(/*Context*/ctx, /*Spec*/spec, /*DOMNode*/refNode, /*Object*/params) {
			// summary: if class specified on spec, then limit store to show only its concrete classes (or itself if none)
			if (spec.rc) {
				params.store = Classes(spec.rc.getConcreteClasses() || [spec.rc]);
				return new InlineSelect(params);
			}

			return this.inherited(arguments);
		},

		_toSortValue: function(/*Any*/value) {
			// summary: return value to be used when sorting by heading
			return locale.type(value) || "";
		}
	});
});